import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { AddGalleryPayload, DeleteGalleryPayload, UpdateGalleryPayload } from './galleryManagement.types';

const createHostGallery = (client: AxiosInstance) => async (payload: AddGalleryPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.ADD_GALLERY, payload)).data;
};

const updateHostGallery = (client: AxiosInstance) => async (payload: UpdateGalleryPayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.UPDATE_GALLERY, payload)).data;
};

const deleteHostGallery = (client: AxiosInstance) => async (payload: DeleteGalleryPayload) => {
  return (
    await client.delete<{ message: string; data: unknown }>(API_ROUTES.DELETE_GALLERY, {
      data: payload,
    })
  ).data;
};

export const galleryManagementMutations = {
  createHostGallery,
  updateHostGallery,
  deleteHostGallery,
};
